import PageHero from "@/components/feature/PageHero";
import { programs } from "@/mocks/skincare";
import ProgramDetail from "./components/ProgramDetail";

export default function Programs() {
  return (
    <>
      <PageHero
        eyebrow="Programs"
        title="피부관리 프로그램"
        description="피부 고민별로 세분화된 6가지 전문 프로그램. 고객님의 피부에 꼭 맞는 관리를 만나보세요."
        image="https://readdy.ai/api/search-image?query=Soft%20elegant%20skincare%20program%20hero%20background%20with%20assorted%20beauty%20products%20and%20delicate%20flowers%20in%20dusty%20pink%20cream%20and%20mint%20tones%20minimalist%20luxurious%20spa%20atmosphere%20bright%20high%20key%20editorial%20aesthetic&width=1920&height=700&seq=bianca-programs-hero&orientation=landscape"
      />

      <section className="w-full px-4 md:px-6 py-16 md:py-24">
        <div className="max-w-6xl mx-auto flex flex-col gap-20 md:gap-28">
          {programs.map((program, index) => (
            <ProgramDetail key={program.id} program={program} index={index} />
          ))}
        </div>
      </section>
    </>
  );
}